import React, { createContext, useContext, useMemo } from 'react';
const FocusedFieldContext = /*#__PURE__*/createContext(undefined);
export const FocusedFieldProvider = _ref => {
  let {
    children
  } = _ref;
  const [focusedFieldId, setFocusedFieldId] = React.useState(undefined);
  const contextValue = useMemo(() => {
    return {
      focusedFieldId,
      setFocusedFieldId
    };
  }, [focusedFieldId, setFocusedFieldId]);
  return /*#__PURE__*/React.createElement(FocusedFieldContext.Provider, {
    value: contextValue
  }, children);
};
export function useFocusedField() {
  const context = useContext(FocusedFieldContext);
  if (context === undefined) {
    throw new Error('useFocusedField must be used within a FocusedFieldProvider');
  }
  return context;
}
//# sourceMappingURL=focused-field-provider.js.map